import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import ValetList from "./ValetList";
import Reports from "../reports/index";

import {
  faCircleCheck,
  faClipboard,
  faHourglass,
  faPeopleGroup,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PoolTipsList from "../PollTips/PoolTipsList";
import VerifiedPoolTipsList from "../PollTips/VerifiedPoolTipsList";

const Valets = ({ toAddMaid, toDeleteMaid, toDownload, isAdmin, canRead }) => {
  const [activeScreen, setActiveScreen] = useState("valets");

  const navButtons = [
    {
      key: "valets",
      label: "Valets",
      icon: faUsers,
    },
    {
      key: "team",
      label: "Pool Tips",
      icon: faPeopleGroup,
    },
    {
      key: "verifiedTips",
      label: "Verified Team Tips",
      icon: faCircleCheck,
    },
    {
      key: "reports",
      label: "Reports",
      icon: faClipboard,
    },
  ];

  return (
    <>
      <Row className="my-4 justify-content-center gx-3">
        {navButtons.map(({ key, label, icon }) => (
          <Col
            key={key}
            xs={6}
            md={3}
            className="d-flex justify-content-center mb-2 mb-md-0"
          >
            <Button
              className="w-100 py-2 rounded-4"
              variant={activeScreen === key ? "primary" : "outline-secondary"}
              onClick={() => setActiveScreen(key)}
            >
              <FontAwesomeIcon icon={icon} className="me-2" />
              {label}
            </Button>
          </Col>
        ))}
      </Row>

      <Row>
        <Col>
          {activeScreen === "valets" && (
            <ValetList toAddMaid={toAddMaid} toDeleteMaid={toDeleteMaid} />
          )}
          {activeScreen === "team" && (
            <PoolTipsList canRead={canRead} service="valet" />
          )}
          {activeScreen === "verifiedTips" && (
            <VerifiedPoolTipsList canRead={canRead} service="valet" />
          )}
          {activeScreen === "reports" && (
            <Reports toDownload={toDownload} isAdmin={isAdmin} type="valet" />
          )}
        </Col>
      </Row>
    </>
  );
};

export default Valets;
